import {Outlet} from "react-router-dom";

export const IndexComponent = () => {
    return (<Outlet/>);
};
